var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.156,
    height: 87.156,
    viewBox: "0 0 87.156 87.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-167 -592.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 87,
    height: 87,
    rx: 17,
    transform: "translate(167 593)",
    fill: "rgba(251,213,213,0.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M17.023,0H70.134A17.056,17.056,0,0,1,87.156,17.023V70.134A17.056,17.056,0,0,1,70.134,87.156H17.023A17.056,17.056,0,0,1,0,70.134V17.023A17.056,17.056,0,0,1,17.023,0ZM59.555,32.707,45.832,18.979a3.192,3.192,0,0,0-4.511,0L27.6,32.707a3.19,3.19,0,1,0,4.511,4.511l8.275-8.276v26.53a3.192,3.192,0,1,0,6.384,0V28.943l8.275,8.275a3.19,3.19,0,1,0,4.511-4.511ZM57.938,65.924a3.191,3.191,0,0,0-3.19-3.194H32.407a3.192,3.192,0,1,0,0,6.384H54.749a3.19,3.19,0,0,0,3.19-3.189Z",
    transform: "translate(167 592.844)",
    fill: "#fff2f2",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon2);
export default __webpack_public_path__ + "static/media/upload_icon2.82922f8e80b7d58103d4c4d1cb1f2ca6.svg";
export { ForwardRef as ReactComponent };